<div> <button mat-icon-button [mat-dialog-close]="{cancel: true}" class="close-dialog">
  <mat-icon>close</mat-icon>
</button>
<h2 mat-dialog-title> {{action}} Status </h2>
<div class="mat-dialog-title-content">
  <div class="scroll-container">
    <eca-form-column>
      <form [formGroup]="form">
        <div class="form-fields">
          <mat-form-field>
            <mat-label>Status Name</mat-label>
            <input matInput formControlName="statusName" required>
            @if (form.controls.statusName.errors?.required) {
              <mat-error>Status Name is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Status Precedence</mat-label>
            <mat-select disableOptionCentering formControlName="statusPrecedence" required>
              @for (opt of [].constructor(100); track $index; let i = $index) {
                <mat-option [value]="i+1">{{i+1}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Status Message</mat-label>
            <input matInput formControlName="statusMessage" required>
            @if (form.controls.statusMessage.errors?.required) {
              <mat-error>Status Message is required</mat-error>
            }
            @if (form.controls.statusMessage.errors?.minlength) {
              <mat-error>Minimum 10 characters requied.</mat-error>
            }
            @if (form.controls.statusMessage.errors?.maxlength) {
              <mat-error>Max 255 characters allowed.</mat-error>
            }
            <mat-hint>message shown on status bar</mat-hint>
          </mat-form-field>

          <!-- <mat-form-field>
          <mat-label>Show Services in Status bar</mat-label>
          <mat-select disableOptionCentering formControlName="showServiceList">
            <mat-option [value]="false"> No </mat-option>
            <mat-option [value]="true"> Yes </mat-option>
          </mat-select>
          <mat-hint>append outage services to message in status bar</mat-hint>
        </mat-form-field> -->

        <mat-form-field>
          <mat-label>Color Code</mat-label>
          <mat-select disableOptionCentering formControlName="statusColorCode"
            (selectionChange)="checkColorChoosen()"
            [ngStyle]="{'background-color': form.controls.statusColorCode?.value == 'Other' ? '#fff' : $safeNavigationMigration(form.controls.statusColorCode?.value)}" required>
            @for (opt of colorCodes; track opt) {
              <mat-option [value]="opt" [ngStyle]="{'background-color': opt}">{{opt}}
              </mat-option>
            }
            <mat-option value="Other">Other</mat-option>
          </mat-select>
        </mat-form-field>
        @if (form.controls.statusColorCode?.value == 'Other') {
          <mat-form-field>
            <mat-label>Other Color Code</mat-label>
            <input matInput formControlName="statusColorCodeOther"
              [ngStyle]="{'background-color': form.controls.statusColorCodeOther?.value == 'Other' ? '#fff' : $safeNavigationMigration(form.controls.statusColorCodeOther?.value)}" required>
            @if (form.controls.statusColorCodeOther.errors?.required) {
              <mat-error>Color Code is required</mat-error>
            }
            @if (form.controls.statusColorCodeOther.errors?.pattern) {
              <mat-error>Should start with # and 3 or 6
              characters code.</mat-error>
            }
            @if (!form.controls.statusColorCodeOther?.value) {
              <mat-hint>Specify color code in Hex format. (ex:
                #FF3123)
              </mat-hint>
            }
          </mat-form-field>
        }
      </div>
    </form>
  </eca-form-column>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="{cancel: true}"> Cancel </button>
  <button mat-button color="primary" [mat-dialog-close]="{cancel: false, form: form}" [disabled]="form.invalid">
  {{action}} Status </button>
</div>
</div>